////////////////////////////////////////////////////////////////////////////////
//                                                                             /
//                                                                             /
//  (C) Copyright 2024 Autodesk, Inc. All rights reserved.                     /
//                                                                             /
//                       ****  CONFIDENTIAL MATERIAL  ****                     /
//                                                                             /
//  The information contained herein is confidential, proprietary to           /
//  Autodesk, Inc., and considered a trade secret.  Use of this information    /
//  by anyone other than authorized employees of Autodesk, Inc. is granted     /
//  only under a written nondisclosure agreement, expressly prescribing the    /
//  the scope and manner of such use.                                          /
//                                                                             /
////////////////////////////////////////////////////////////////////////////////

import {
  BitFile,
  CheckSet,
  CheckSetDto,
  CustomerInfo, Directory360,
  EmailPreferences,
  ExportReportLocationType, File360,
  FileDestinationNamingType,
  FileDto,
  IPaginatedCount,
  Job,
  JobDirectory,
  JobFile,
  JobRunItemStatusType,
  JobRunStatusType,
  PaginatedCount, PaginationData, Project,
  ProjectWiseDirectory,
  ProjectWiseFile,
  ReportCheckResultCondition,
  ReportCheckResultType,
  ReportCheckType,
  UsageExportFormat,
  UsageExportType,
  UsageSortType
} from "./Classes";

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */

// ReSharper disable InconsistentNaming


export class PaginatedResultOfCheckSet extends PaginatedCount implements IPaginatedResultOfCheckSet {
  items?: CheckSet[];

  constructor(data?: IPaginatedResultOfCheckSet) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(CheckSet.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfCheckSet {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfCheckSet();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfCheckSet extends IPaginatedCount {
  items?: CheckSet[];
}

export class ChecksetPaginatedResult extends PaginatedResultOfCheckSet implements IChecksetPaginatedResult {

  constructor(data?: IChecksetPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ChecksetPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ChecksetPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IChecksetPaginatedResult extends IPaginatedResultOfCheckSet {
}

export class ExportStatusDto implements IExportStatusDto {
  reportId?: string;
  statusId?: string | undefined;
  isReady?: boolean;

  constructor(data?: IExportStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reportId = _data["reportId"];
      this.statusId = _data["statusId"];
      this.isReady = _data["isReady"];
    }
  }

  static fromJS(data: any): ExportStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExportStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportId"] = this.reportId;
    data["statusId"] = this.statusId;
    data["isReady"] = this.isReady;
    return data;
  }
}

export interface IExportStatusDto {
  reportId?: string;
  statusId?: string | undefined;
  isReady?: boolean;
}

/** Represents a download for a report. */
export class ExportResultDto extends ExportStatusDto implements IExportResultDto {
  exports?: { [key: string]: ExportResultFormatDto; };

  constructor(data?: IExportResultDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (_data["exports"]) {
        this.exports = {} as any;
        for (let key in _data["exports"]) {
          if (_data["exports"].hasOwnProperty(key))
            (this.exports as any)![key] = _data["exports"][key] ? ExportResultFormatDto.fromJS(_data["exports"][key]) : new ExportResultFormatDto();
        }
      }
    }
  }

  static override fromJS(data: any): ExportResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExportResultDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.exports) {
      data["exports"] = {};
      for (let key in this.exports) {
        if (this.exports.hasOwnProperty(key))
          (data["exports"] as any)[key] = this.exports[key] ? this.exports[key].toJSON() : undefined as any;
      }
    }
    super.toJSON(data);
    return data;
  }
}

/** Represents a download for a report. */
export interface IExportResultDto extends IExportStatusDto {
  exports?: { [key: string]: ExportResultFormatDto; };
}

export class ExportResultFormatDto implements IExportResultFormatDto {
  format?: string;
  failureMessage?: string | undefined;
  fileName?: string | undefined;
  exportUri?: string | undefined;
  bim360ProjectId?: string | undefined;
  bim360ItemId?: string | undefined;
  exportS3Key?: string | undefined;

  constructor(data?: IExportResultFormatDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.format = _data["format"];
      this.failureMessage = _data["failureMessage"];
      this.fileName = _data["fileName"];
      this.exportUri = _data["exportUri"];
      this.bim360ProjectId = _data["bim360ProjectId"];
      this.bim360ItemId = _data["bim360ItemId"];
      this.exportS3Key = _data["exportS3Key"];
    }
  }

  static fromJS(data: any): ExportResultFormatDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExportResultFormatDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["format"] = this.format;
    data["failureMessage"] = this.failureMessage;
    data["fileName"] = this.fileName;
    data["exportUri"] = this.exportUri;
    data["bim360ProjectId"] = this.bim360ProjectId;
    data["bim360ItemId"] = this.bim360ItemId;
    data["exportS3Key"] = this.exportS3Key;
    return data;
  }
}

export interface IExportResultFormatDto {
  format?: string;
  failureMessage?: string | undefined;
  fileName?: string | undefined;
  exportUri?: string | undefined;
  bim360ProjectId?: string | undefined;
  bim360ItemId?: string | undefined;
  exportS3Key?: string | undefined;
}

/** Defines a request to export a report. */
export class ExportReportRequestOfAvtExportReportOptions implements IExportReportRequestOfAvtExportReportOptions {
  options?: AvtExportReportOptions | undefined;
  reportId?: string;
  jobRunId?: string | undefined;

  constructor(data?: IExportReportRequestOfAvtExportReportOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.options = _data["options"] ? AvtExportReportOptions.fromJS(_data["options"]) : undefined as any;
      this.reportId = _data["reportId"];
      this.jobRunId = _data["jobRunId"];
    }
  }

  static fromJS(data: any): ExportReportRequestOfAvtExportReportOptions {
    data = typeof data === 'object' ? data : {};
    let result = new ExportReportRequestOfAvtExportReportOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["options"] = this.options ? this.options.toJSON() : undefined as any;
    data["reportId"] = this.reportId;
    data["jobRunId"] = this.jobRunId;
    return data;
  }
}

/** Defines a request to export a report. */
export interface IExportReportRequestOfAvtExportReportOptions {
  options?: AvtExportReportOptions | undefined;
  reportId?: string;
  jobRunId?: string | undefined;
}

export class AvtExportReportRequest extends ExportReportRequestOfAvtExportReportOptions implements IAvtExportReportRequest {

  constructor(data?: IAvtExportReportRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): AvtExportReportRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AvtExportReportRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IAvtExportReportRequest extends IExportReportRequestOfAvtExportReportOptions {
}

export class ExportReportOptions implements IExportReportOptions {
  /** Gets or sets the export location type. */
  locationType?: ExportReportLocationType;
  /** Gets or sets the naming type for the export. Valid values are Overwrite and AppendTimestamp. */
  destinationNamingType?: FileDestinationNamingType;
  /** Gets or sets the project ID for a custom export location. LocationDirectoryId must also be set. */
  locationProjectId?: string | undefined;
  /** Gets or sets the directory ID for a custom export location. LocationProjectId must also be set. */
  locationDirectoryId?: string | undefined;
  /** Gets or sets set the email preferences for exporting the report. When exporting a report as a standalone command,
   these
   preferences are respected.  When exporting reports as part of a scheduled job, the preferences on the job itself
   are respected, and any value set here will be ignored.
   */
  emailPreferences?: EmailPreferences | undefined;
  /** Gets or sets a value for a custom file suffix. Mainly used for testing. */
  customFileSuffix?: string | undefined;
  /** Gets a value indicating whether this export has a destination, i.e. is not a direct download. */
  hasExportDestination?: boolean;
  /** Gets or sets a list of the formats to export. See the /report/supportedFormats endpoint for a list of valid values. */
  exportFormats?: string[];
  /** Gets or sets a value indicating whether to force the export to run again, even if it already exists. */
  force?: boolean;

  constructor(data?: IExportReportOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationType = _data["locationType"];
      this.destinationNamingType = _data["destinationNamingType"];
      this.locationProjectId = _data["locationProjectId"];
      this.locationDirectoryId = _data["locationDirectoryId"];
      this.emailPreferences = _data["emailPreferences"] ? EmailPreferences.fromJS(_data["emailPreferences"]) : undefined as any;
      this.customFileSuffix = _data["customFileSuffix"];
      this.hasExportDestination = _data["hasExportDestination"];
      if (Array.isArray(_data["exportFormats"])) {
        this.exportFormats = [] as any;
        for (let item of _data["exportFormats"])
          this.exportFormats!.push(item);
      }
      this.force = _data["force"];
    }
  }

  static fromJS(data: any): ExportReportOptions {
    data = typeof data === 'object' ? data : {};
    let result = new ExportReportOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["locationType"] = this.locationType;
    data["destinationNamingType"] = this.destinationNamingType;
    data["locationProjectId"] = this.locationProjectId;
    data["locationDirectoryId"] = this.locationDirectoryId;
    data["emailPreferences"] = this.emailPreferences ? this.emailPreferences.toJSON() : undefined as any;
    data["customFileSuffix"] = this.customFileSuffix;
    data["hasExportDestination"] = this.hasExportDestination;
    if (Array.isArray(this.exportFormats)) {
      data["exportFormats"] = [];
      for (let item of this.exportFormats)
        data["exportFormats"].push(item);
    }
    data["force"] = this.force;
    return data;
  }
}

export interface IExportReportOptions {
  /** Gets or sets the export location type. */
  locationType?: ExportReportLocationType;
  /** Gets or sets the naming type for the export. Valid values are Overwrite and AppendTimestamp. */
  destinationNamingType?: FileDestinationNamingType;
  /** Gets or sets the project ID for a custom export location. LocationDirectoryId must also be set. */
  locationProjectId?: string | undefined;
  /** Gets or sets the directory ID for a custom export location. LocationProjectId must also be set. */
  locationDirectoryId?: string | undefined;
  /** Gets or sets set the email preferences for exporting the report. When exporting a report as a standalone command,
   these
   preferences are respected.  When exporting reports as part of a scheduled job, the preferences on the job itself
   are respected, and any value set here will be ignored.
   */
  emailPreferences?: EmailPreferences | undefined;
  /** Gets or sets a value for a custom file suffix. Mainly used for testing. */
  customFileSuffix?: string | undefined;
  /** Gets a value indicating whether this export has a destination, i.e. is not a direct download. */
  hasExportDestination?: boolean;
  /** Gets or sets a list of the formats to export. See the /report/supportedFormats endpoint for a list of valid values. */
  exportFormats?: string[];
  /** Gets or sets a value indicating whether to force the export to run again, even if it already exists. */
  force?: boolean;
}

export class AvtExportReportOptions extends ExportReportOptions implements IAvtExportReportOptions {
  combineReports?: boolean;
  combineExcel?: boolean;
  doNotZipHtml?: boolean;
  excel?: boolean;
  html?: boolean;
  exportLists?: boolean;
  offline?: boolean;

  constructor(data?: IAvtExportReportOptions) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.combineReports = _data["combineReports"];
      this.combineExcel = _data["combineExcel"];
      this.doNotZipHtml = _data["doNotZipHtml"];
      this.excel = _data["excel"];
      this.html = _data["html"];
      this.exportLists = _data["exportLists"];
      this.offline = _data["offline"];
    }
  }

  static override fromJS(data: any): AvtExportReportOptions {
    data = typeof data === 'object' ? data : {};
    let result = new AvtExportReportOptions();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["combineReports"] = this.combineReports;
    data["combineExcel"] = this.combineExcel;
    data["doNotZipHtml"] = this.doNotZipHtml;
    data["excel"] = this.excel;
    data["html"] = this.html;
    data["exportLists"] = this.exportLists;
    data["offline"] = this.offline;
    super.toJSON(data);
    return data;
  }
}

export interface IAvtExportReportOptions extends IExportReportOptions {
  combineReports?: boolean;
  combineExcel?: boolean;
  doNotZipHtml?: boolean;
  excel?: boolean;
  html?: boolean;
  exportLists?: boolean;
  offline?: boolean;
}

export class BatchDeleteResponse implements IBatchDeleteResponse {
  failedIds?: BatchDeleteError[];
  successfulIds?: string[];

  constructor(data?: IBatchDeleteResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["failedIds"])) {
        this.failedIds = [] as any;
        for (let item of _data["failedIds"])
          this.failedIds!.push(BatchDeleteError.fromJS(item));
      }
      if (Array.isArray(_data["successfulIds"])) {
        this.successfulIds = [] as any;
        for (let item of _data["successfulIds"])
          this.successfulIds!.push(item);
      }
    }
  }

  static fromJS(data: any): BatchDeleteResponse {
    data = typeof data === 'object' ? data : {};
    let result = new BatchDeleteResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.failedIds)) {
      data["failedIds"] = [];
      for (let item of this.failedIds)
        data["failedIds"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.successfulIds)) {
      data["successfulIds"] = [];
      for (let item of this.successfulIds)
        data["successfulIds"].push(item);
    }
    return data;
  }
}

export interface IBatchDeleteResponse {
  failedIds?: BatchDeleteError[];
  successfulIds?: string[];
}

export class BatchDeleteError implements IBatchDeleteError {
  id?: string;
  error?: string;

  constructor(data?: IBatchDeleteError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.error = _data["error"];
    }
  }

  static fromJS(data: any): BatchDeleteError {
    data = typeof data === 'object' ? data : {};
    let result = new BatchDeleteError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["error"] = this.error;
    return data;
  }
}

export interface IBatchDeleteError {
  id?: string;
  error?: string;
}

export class ReportSummaryDto implements IReportSummaryDto {
  reportId?: string;
  reportKey?: string | undefined;
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
  startTime?: Date;
  endTime?: Date;
  jobName?: string;
  jobDescription?: string | undefined;
  jobId?: string;
  jobRunId?: string;
  status?: JobRunStatusType;
  userId?: string;
  email?: string;
  customerId?: string;
  files?: FileDto[];
  errorMessage?: string | undefined;

  constructor(data?: IReportSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reportId = _data["reportId"];
      this.reportKey = _data["reportKey"];
      this.totalFiles = _data["totalFiles"];
      this.successFiles = _data["successFiles"];
      this.failedFiles = _data["failedFiles"];
      this.pendingFiles = _data["pendingFiles"];
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
      this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
      this.jobName = _data["jobName"];
      this.jobDescription = _data["jobDescription"];
      this.jobId = _data["jobId"];
      this.jobRunId = _data["jobRunId"];
      this.status = _data["status"];
      this.userId = _data["userId"];
      this.email = _data["email"];
      this.customerId = _data["customerId"];
      if (Array.isArray(_data["files"])) {
        this.files = [] as any;
        for (let item of _data["files"])
          this.files!.push(FileDto.fromJS(item));
      }
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): ReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReportSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportId"] = this.reportId;
    data["reportKey"] = this.reportKey;
    data["totalFiles"] = this.totalFiles;
    data["successFiles"] = this.successFiles;
    data["failedFiles"] = this.failedFiles;
    data["pendingFiles"] = this.pendingFiles;
    data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
    data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
    data["jobName"] = this.jobName;
    data["jobDescription"] = this.jobDescription;
    data["jobId"] = this.jobId;
    data["jobRunId"] = this.jobRunId;
    data["status"] = this.status;
    data["userId"] = this.userId;
    data["email"] = this.email;
    data["customerId"] = this.customerId;
    if (Array.isArray(this.files)) {
      data["files"] = [];
      for (let item of this.files)
        data["files"].push(item ? item.toJSON() : undefined as any);
    }
    data["errorMessage"] = this.errorMessage;
    return data;
  }
}

export interface IReportSummaryDto {
  reportId?: string;
  reportKey?: string | undefined;
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
  startTime?: Date;
  endTime?: Date;
  jobName?: string;
  jobDescription?: string | undefined;
  jobId?: string;
  jobRunId?: string;
  status?: JobRunStatusType;
  userId?: string;
  email?: string;
  customerId?: string;
  files?: FileDto[];
  errorMessage?: string | undefined;
}

export class AvtReportSummaryDto extends ReportSummaryDto implements IAvtReportSummaryDto {
  reportUri?: string | undefined;
  isCombined?: boolean;
  /** Gets or sets the date of this run.
   */
  runDate?: Date;
  checkSetId?: string | undefined;
  /** Gets or sets the UI display string of the initialization date/time.
   */
  dateDisplay?: string | undefined;
  summaryInfo?: AvtReportDtoBase;

  constructor(data?: IAvtReportSummaryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.reportUri = _data["reportUri"];
      this.isCombined = _data["isCombined"];
      this.runDate = _data["runDate"] ? new Date(_data["runDate"].toString()) : undefined as any;
      this.checkSetId = _data["checkSetId"];
      this.dateDisplay = _data["dateDisplay"];
      this.summaryInfo = _data["summaryInfo"] ? AvtReportDtoBase.fromJS(_data["summaryInfo"]) : undefined as any;
    }
  }

  static override fromJS(data: any): AvtReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new AvtReportSummaryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportUri"] = this.reportUri;
    data["isCombined"] = this.isCombined;
    data["runDate"] = this.runDate ? this.runDate.toISOString() : undefined as any;
    data["checkSetId"] = this.checkSetId;
    data["dateDisplay"] = this.dateDisplay;
    data["summaryInfo"] = this.summaryInfo ? this.summaryInfo.toJSON() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IAvtReportSummaryDto extends IReportSummaryDto {
  reportUri?: string | undefined;
  isCombined?: boolean;
  /** Gets or sets the date of this run.
   */
  runDate?: Date;
  checkSetId?: string | undefined;
  /** Gets or sets the UI display string of the initialization date/time.
   */
  dateDisplay?: string | undefined;
  summaryInfo?: AvtReportDtoBase;
}

export class AvtReportDto extends AvtReportSummaryDto implements IAvtReportDto {
  /** Gets or sets the list of file results for this run.
   */
  fileResults?: AvtReportFileDto[];
  /** Gets or sets the check set for this run.
   */
  checkSet?: CheckSetDto | undefined;

  constructor(data?: IAvtReportDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["fileResults"])) {
        this.fileResults = [] as any;
        for (let item of _data["fileResults"])
          this.fileResults!.push(AvtReportFileDto.fromJS(item));
      }
      this.checkSet = _data["checkSet"] ? CheckSetDto.fromJS(_data["checkSet"]) : undefined as any;
    }
  }

  static override fromJS(data: any): AvtReportDto {
    data = typeof data === 'object' ? data : {};
    let result = new AvtReportDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.fileResults)) {
      data["fileResults"] = [];
      for (let item of this.fileResults)
        data["fileResults"].push(item ? item.toJSON() : undefined as any);
    }
    data["checkSet"] = this.checkSet ? this.checkSet.toJSON() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IAvtReportDto extends IAvtReportSummaryDto {
  /** Gets or sets the list of file results for this run.
   */
  fileResults?: AvtReportFileDto[];
  /** Gets or sets the check set for this run.
   */
  checkSet?: CheckSetDto | undefined;
}

export class AvtReportDtoBase implements IAvtReportDtoBase {
  totalChecks?: number;
  id?: string;
  passChecks?: number;
  failChecks?: number;
  headerValue?: string | undefined;
  countChecks?: number;
  description?: string | undefined;
  skippedChecks?: number;
  errorChecks?: number;
  passPercent?: number;

  constructor(data?: IAvtReportDtoBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalChecks = _data["totalChecks"];
      this.id = _data["id"];
      this.passChecks = _data["passChecks"];
      this.failChecks = _data["failChecks"];
      this.headerValue = _data["headerValue"];
      this.countChecks = _data["countChecks"];
      this.description = _data["description"];
      this.skippedChecks = _data["skippedChecks"];
      this.errorChecks = _data["errorChecks"];
      this.passPercent = _data["passPercent"];
    }
  }

  static fromJS(data: any): AvtReportDtoBase {
    data = typeof data === 'object' ? data : {};
    let result = new AvtReportDtoBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalChecks"] = this.totalChecks;
    data["id"] = this.id;
    data["passChecks"] = this.passChecks;
    data["failChecks"] = this.failChecks;
    data["headerValue"] = this.headerValue;
    data["countChecks"] = this.countChecks;
    data["description"] = this.description;
    data["skippedChecks"] = this.skippedChecks;
    data["errorChecks"] = this.errorChecks;
    data["passPercent"] = this.passPercent;
    return data;
  }
}

export interface IAvtReportDtoBase {
  totalChecks?: number;
  id?: string;
  passChecks?: number;
  failChecks?: number;
  headerValue?: string | undefined;
  countChecks?: number;
  description?: string | undefined;
  skippedChecks?: number;
  errorChecks?: number;
  passPercent?: number;
}

export class AvtReportFileDto extends AvtReportDtoBase implements IAvtReportFileDto {
  reportId?: string | undefined;
  model?: JobFile | undefined;
  overallResult?: ReportCheckResultType;
  headings?: ReportHeadingDto[];
  revitFile?: string | undefined;
  hasPassFail?: boolean;

  constructor(data?: IAvtReportFileDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.reportId = _data["reportId"];
      this.model = _data["model"] ? JobFile.fromJS(_data["model"]) : undefined as any;
      this.overallResult = _data["overallResult"];
      if (Array.isArray(_data["headings"])) {
        this.headings = [] as any;
        for (let item of _data["headings"])
          this.headings!.push(ReportHeadingDto.fromJS(item));
      }
      this.revitFile = _data["revitFile"];
      this.hasPassFail = _data["hasPassFail"];
    }
  }

  static override fromJS(data: any): AvtReportFileDto {
    data = typeof data === 'object' ? data : {};
    let result = new AvtReportFileDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportId"] = this.reportId;
    data["model"] = this.model ? this.model.toJSON() : undefined as any;
    data["overallResult"] = this.overallResult;
    if (Array.isArray(this.headings)) {
      data["headings"] = [];
      for (let item of this.headings)
        data["headings"].push(item ? item.toJSON() : undefined as any);
    }
    data["revitFile"] = this.revitFile;
    data["hasPassFail"] = this.hasPassFail;
    super.toJSON(data);
    return data;
  }
}

export interface IAvtReportFileDto extends IAvtReportDtoBase {
  reportId?: string | undefined;
  model?: JobFile | undefined;
  overallResult?: ReportCheckResultType;
  headings?: ReportHeadingDto[];
  revitFile?: string | undefined;
  hasPassFail?: boolean;
}

export enum CloudFileType {
  Standard = "Standard",
  Cloud = "Cloud",
  CloudWorkshared = "CloudWorkshared",
}

export enum ProjectWiseFileClass {
  Document = "Document",
  LogicalSet = "LogicalSet",
  FlatSet = "FlatSet",
}

export class ReportHeadingDto extends AvtReportDtoBase implements IReportHeadingDto {
  reportFileId?: string | undefined;
  sections?: ReportSectionDto[];

  constructor(data?: IReportHeadingDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.reportFileId = _data["reportFileId"];
      if (Array.isArray(_data["sections"])) {
        this.sections = [] as any;
        for (let item of _data["sections"])
          this.sections!.push(ReportSectionDto.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): ReportHeadingDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReportHeadingDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportFileId"] = this.reportFileId;
    if (Array.isArray(this.sections)) {
      data["sections"] = [];
      for (let item of this.sections)
        data["sections"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IReportHeadingDto extends IAvtReportDtoBase {
  reportFileId?: string | undefined;
  sections?: ReportSectionDto[];
}

export class ReportSectionDto extends AvtReportDtoBase implements IReportSectionDto {
  reportHeadingId?: string | undefined;
  reportSectionId?: string | undefined;
  /** Gets or sets the section name i.e. 4.1.2.
   */
  name?: string | undefined;
  /** Gets or sets the section title i.e. Model Data.
   */
  title?: string | undefined;
  /** Gets or sets the list of sections that are a subsection of this section.
   */
  subSections?: ReportSectionDto[];
  /** Gets or sets the list of checks directly associated to this section.
   */
  checks?: ReportCheckDto[];

  constructor(data?: IReportSectionDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.reportHeadingId = _data["reportHeadingId"];
      this.reportSectionId = _data["reportSectionId"];
      this.name = _data["name"];
      this.title = _data["title"];
      if (Array.isArray(_data["subSections"])) {
        this.subSections = [] as any;
        for (let item of _data["subSections"])
          this.subSections!.push(ReportSectionDto.fromJS(item));
      }
      if (Array.isArray(_data["checks"])) {
        this.checks = [] as any;
        for (let item of _data["checks"])
          this.checks!.push(ReportCheckDto.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): ReportSectionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReportSectionDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportHeadingId"] = this.reportHeadingId;
    data["reportSectionId"] = this.reportSectionId;
    data["name"] = this.name;
    data["title"] = this.title;
    if (Array.isArray(this.subSections)) {
      data["subSections"] = [];
      for (let item of this.subSections)
        data["subSections"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.checks)) {
      data["checks"] = [];
      for (let item of this.checks)
        data["checks"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IReportSectionDto extends IAvtReportDtoBase {
  reportHeadingId?: string | undefined;
  reportSectionId?: string | undefined;
  /** Gets or sets the section name i.e. 4.1.2.
   */
  name?: string | undefined;
  /** Gets or sets the section title i.e. Model Data.
   */
  title?: string | undefined;
  /** Gets or sets the list of sections that are a subsection of this section.
   */
  subSections?: ReportSectionDto[];
  /** Gets or sets the list of checks directly associated to this section.
   */
  checks?: ReportCheckDto[];
}

export class ReportCheckDto extends AvtReportDtoBase implements IReportCheckDto {
  reportSectionId?: string | undefined;
  /** Gets or sets a value indicating whether if this check is required or optional.
   */
  isRequired?: boolean;
  /** Gets or sets the name of this check.
   */
  name?: string | undefined;
  /** Gets or sets the type of check.
   */
  checkType?: ReportCheckType;
  /** Gets or sets the desired condition for calculating the result.
   */
  resultCondition?: ReportCheckResultCondition;
  /** Gets or sets the message to display if this check fails.
   */
  failureMessage?: string | undefined;
  /** Gets or sets the result of the check run.
   */
  checkResult?: ReportCheckResultDto | undefined;
  isReporting?: boolean;

  constructor(data?: IReportCheckDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.reportSectionId = _data["reportSectionId"];
      this.isRequired = _data["isRequired"];
      this.name = _data["name"];
      this.checkType = _data["checkType"];
      this.resultCondition = _data["resultCondition"];
      this.failureMessage = _data["failureMessage"];
      this.checkResult = _data["checkResult"] ? ReportCheckResultDto.fromJS(_data["checkResult"]) : undefined as any;
      this.isReporting = _data["isReporting"];
    }
  }

  static override fromJS(data: any): ReportCheckDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReportCheckDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportSectionId"] = this.reportSectionId;
    data["isRequired"] = this.isRequired;
    data["name"] = this.name;
    data["checkType"] = this.checkType;
    data["resultCondition"] = this.resultCondition;
    data["failureMessage"] = this.failureMessage;
    data["checkResult"] = this.checkResult ? this.checkResult.toJSON() : undefined as any;
    data["isReporting"] = this.isReporting;
    super.toJSON(data);
    return data;
  }
}

export interface IReportCheckDto extends IAvtReportDtoBase {
  reportSectionId?: string | undefined;
  /** Gets or sets a value indicating whether if this check is required or optional.
   */
  isRequired?: boolean;
  /** Gets or sets the name of this check.
   */
  name?: string | undefined;
  /** Gets or sets the type of check.
   */
  checkType?: ReportCheckType;
  /** Gets or sets the desired condition for calculating the result.
   */
  resultCondition?: ReportCheckResultCondition;
  /** Gets or sets the message to display if this check fails.
   */
  failureMessage?: string | undefined;
  /** Gets or sets the result of the check run.
   */
  checkResult?: ReportCheckResultDto | undefined;
  isReporting?: boolean;
}

/** Represents the result of a check that was run. */
export class ReportCheckResultDto implements IReportCheckResultDto {
  reportCheckId?: string | undefined;
  /** Gets or sets the string to display as the total.
   */
  totalDisplay?: string | undefined;
  /** Gets or sets the list of found elements.
   */
  listItems?: ReportElementDataDto[];
  /** Gets or sets a value indicating whether the values should be shown.
   */
  showValues?: boolean;
  /** Gets or sets a custom value for the result.
   */
  resultCustomValue?: string | undefined;
  /** Gets or sets the error message if an error was encountered.
   */
  errorMessage?: string | undefined;
  /** Gets or sets a value indicating whether if the check run has completed.  This should be set by check runners only.
   */
  checkWasRun?: boolean;
  /** Gets or sets a value indicating whether if an error was encountered in this run.
   */
  hasError?: boolean;
  /** Gets or sets the type of result from the run.
   */
  result?: ReportCheckResultType;
  reportResultTooltip?: string | undefined;
  showFailureMessage?: boolean;
  showTotalCount?: boolean;
  hasCustomValue?: boolean;
  showList?: boolean;
  showCountColumn?: boolean;

  constructor(data?: IReportCheckResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reportCheckId = _data["reportCheckId"];
      this.totalDisplay = _data["totalDisplay"];
      if (Array.isArray(_data["listItems"])) {
        this.listItems = [] as any;
        for (let item of _data["listItems"])
          this.listItems!.push(ReportElementDataDto.fromJS(item));
      }
      this.showValues = _data["showValues"];
      this.resultCustomValue = _data["resultCustomValue"];
      this.errorMessage = _data["errorMessage"];
      this.checkWasRun = _data["checkWasRun"];
      this.hasError = _data["hasError"];
      this.result = _data["result"];
      this.reportResultTooltip = _data["reportResultTooltip"];
      this.showFailureMessage = _data["showFailureMessage"];
      this.showTotalCount = _data["showTotalCount"];
      this.hasCustomValue = _data["hasCustomValue"];
      this.showList = _data["showList"];
      this.showCountColumn = _data["showCountColumn"];
    }
  }

  static fromJS(data: any): ReportCheckResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReportCheckResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportCheckId"] = this.reportCheckId;
    data["totalDisplay"] = this.totalDisplay;
    if (Array.isArray(this.listItems)) {
      data["listItems"] = [];
      for (let item of this.listItems)
        data["listItems"].push(item ? item.toJSON() : undefined as any);
    }
    data["showValues"] = this.showValues;
    data["resultCustomValue"] = this.resultCustomValue;
    data["errorMessage"] = this.errorMessage;
    data["checkWasRun"] = this.checkWasRun;
    data["hasError"] = this.hasError;
    data["result"] = this.result;
    data["reportResultTooltip"] = this.reportResultTooltip;
    data["showFailureMessage"] = this.showFailureMessage;
    data["showTotalCount"] = this.showTotalCount;
    data["hasCustomValue"] = this.hasCustomValue;
    data["showList"] = this.showList;
    data["showCountColumn"] = this.showCountColumn;
    return data;
  }
}

/** Represents the result of a check that was run. */
export interface IReportCheckResultDto {
  reportCheckId?: string | undefined;
  /** Gets or sets the string to display as the total.
   */
  totalDisplay?: string | undefined;
  /** Gets or sets the list of found elements.
   */
  listItems?: ReportElementDataDto[];
  /** Gets or sets a value indicating whether the values should be shown.
   */
  showValues?: boolean;
  /** Gets or sets a custom value for the result.
   */
  resultCustomValue?: string | undefined;
  /** Gets or sets the error message if an error was encountered.
   */
  errorMessage?: string | undefined;
  /** Gets or sets a value indicating whether if the check run has completed.  This should be set by check runners only.
   */
  checkWasRun?: boolean;
  /** Gets or sets a value indicating whether if an error was encountered in this run.
   */
  hasError?: boolean;
  /** Gets or sets the type of result from the run.
   */
  result?: ReportCheckResultType;
  reportResultTooltip?: string | undefined;
  showFailureMessage?: boolean;
  showTotalCount?: boolean;
  hasCustomValue?: boolean;
  showList?: boolean;
  showCountColumn?: boolean;
}

export class ReportElementDataDto implements IReportElementDataDto {
  id?: number;
  familyName?: string | undefined;
  typeName?: string | undefined;
  categoryName?: string | undefined;
  name?: string | undefined;
  /** Gets or sets the count of items being represented by this element object, defaults to 1.
   */
  itemsCount?: number;
  /** Gets or sets a piece of value data.
   */
  value?: string | undefined;
  /** Gets or sets a value indicating whether if this element can be shown in the Revit interface (should be true for
   instances
   and false for types).
   */
  allowShow?: boolean;
  hasCategory?: boolean;
  hasFamily?: boolean;
  hasType?: boolean;
  hasName?: boolean;

  constructor(data?: IReportElementDataDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.familyName = _data["familyName"];
      this.typeName = _data["typeName"];
      this.categoryName = _data["categoryName"];
      this.name = _data["name"];
      this.itemsCount = _data["itemsCount"];
      this.value = _data["value"];
      this.allowShow = _data["allowShow"];
      this.hasCategory = _data["hasCategory"];
      this.hasFamily = _data["hasFamily"];
      this.hasType = _data["hasType"];
      this.hasName = _data["hasName"];
    }
  }

  static fromJS(data: any): ReportElementDataDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReportElementDataDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["familyName"] = this.familyName;
    data["typeName"] = this.typeName;
    data["categoryName"] = this.categoryName;
    data["name"] = this.name;
    data["itemsCount"] = this.itemsCount;
    data["value"] = this.value;
    data["allowShow"] = this.allowShow;
    data["hasCategory"] = this.hasCategory;
    data["hasFamily"] = this.hasFamily;
    data["hasType"] = this.hasType;
    data["hasName"] = this.hasName;
    return data;
  }
}

export interface IReportElementDataDto {
  id?: number;
  familyName?: string | undefined;
  typeName?: string | undefined;
  categoryName?: string | undefined;
  name?: string | undefined;
  /** Gets or sets the count of items being represented by this element object, defaults to 1.
   */
  itemsCount?: number;
  /** Gets or sets a piece of value data.
   */
  value?: string | undefined;
  /** Gets or sets a value indicating whether if this element can be shown in the Revit interface (should be true for
   instances
   and false for types).
   */
  allowShow?: boolean;
  hasCategory?: boolean;
  hasFamily?: boolean;
  hasType?: boolean;
  hasName?: boolean;
}

export class PaginatedResultOfJob extends PaginatedCount implements IPaginatedResultOfJob {
  items?: Job[];

  constructor(data?: IPaginatedResultOfJob) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(Job.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfJob {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfJob();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfJob extends IPaginatedCount {
  items?: Job[];
}

export class JobPaginatedResult extends PaginatedResultOfJob implements IJobPaginatedResult {

  constructor(data?: IJobPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): JobPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new JobPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IJobPaginatedResult extends IPaginatedResultOfJob {
}

export class WorkItemDto implements IWorkItemDto {
  id?: string | undefined;
  activityId?: string;
  arguments?: { [key: string]: ArgumentDto; };
  signatures?: WorkItemSignaturesDto | undefined;
  limitProcessingTimeSec?: number | undefined;

  constructor(data?: IWorkItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.activityId = _data["activityId"];
      if (_data["arguments"]) {
        this.arguments = {} as any;
        for (let key in _data["arguments"]) {
          if (_data["arguments"].hasOwnProperty(key))
            (this.arguments as any)![key] = _data["arguments"][key] ? ArgumentDto.fromJS(_data["arguments"][key]) : new ArgumentDto();
        }
      }
      this.signatures = _data["signatures"] ? WorkItemSignaturesDto.fromJS(_data["signatures"]) : undefined as any;
      this.limitProcessingTimeSec = _data["limitProcessingTimeSec"];
    }
  }

  static fromJS(data: any): WorkItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new WorkItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["activityId"] = this.activityId;
    if (this.arguments) {
      data["arguments"] = {};
      for (let key in this.arguments) {
        if (this.arguments.hasOwnProperty(key))
          (data["arguments"] as any)[key] = this.arguments[key] ? this.arguments[key].toJSON() : undefined as any;
      }
    }
    data["signatures"] = this.signatures ? this.signatures.toJSON() : undefined as any;
    data["limitProcessingTimeSec"] = this.limitProcessingTimeSec;
    return data;
  }
}

export interface IWorkItemDto {
  id?: string | undefined;
  activityId?: string;
  arguments?: { [key: string]: ArgumentDto; };
  signatures?: WorkItemSignaturesDto | undefined;
  limitProcessingTimeSec?: number | undefined;
}

export class ArgumentDto implements IArgumentDto {

  constructor(data?: IArgumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): ArgumentDto {
    data = typeof data === 'object' ? data : {};
    let result = new ArgumentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    return data;
  }
}

export interface IArgumentDto {
}

export class WorkItemSignaturesDto implements IWorkItemSignaturesDto {
  activityId?: string;
  baseUrls?: SignedUrlDto[];

  constructor(data?: IWorkItemSignaturesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activityId = _data["activityId"];
      if (Array.isArray(_data["baseUrls"])) {
        this.baseUrls = [] as any;
        for (let item of _data["baseUrls"])
          this.baseUrls!.push(SignedUrlDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): WorkItemSignaturesDto {
    data = typeof data === 'object' ? data : {};
    let result = new WorkItemSignaturesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["activityId"] = this.activityId;
    if (Array.isArray(this.baseUrls)) {
      data["baseUrls"] = [];
      for (let item of this.baseUrls)
        data["baseUrls"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface IWorkItemSignaturesDto {
  activityId?: string;
  baseUrls?: SignedUrlDto[];
}

export class SignedUrlDto implements ISignedUrlDto {
  url?: string;
  signature?: string;

  constructor(data?: ISignedUrlDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data["url"];
      this.signature = _data["signature"];
    }
  }

  static fromJS(data: any): SignedUrlDto {
    data = typeof data === 'object' ? data : {};
    let result = new SignedUrlDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["url"] = this.url;
    data["signature"] = this.signature;
    return data;
  }
}

export interface ISignedUrlDto {
  url?: string;
  signature?: string;
}

export class JobStats implements IJobStats {
  timeDownloadStarted?: Date | undefined;
  timeInstructionsEnded?: Date | undefined;
  timeInstructionsStarted?: Date | undefined;
  timeQueued?: Date | undefined;
  timeUploadEnded?: Date | undefined;
  timeFinished?: Date | undefined;
  bytesDownloaded?: number | undefined;
  bytesUploaded?: number | undefined;

  constructor(data?: IJobStats) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.timeDownloadStarted = _data["timeDownloadStarted"] ? new Date(_data["timeDownloadStarted"].toString()) : undefined as any;
      this.timeInstructionsEnded = _data["timeInstructionsEnded"] ? new Date(_data["timeInstructionsEnded"].toString()) : undefined as any;
      this.timeInstructionsStarted = _data["timeInstructionsStarted"] ? new Date(_data["timeInstructionsStarted"].toString()) : undefined as any;
      this.timeQueued = _data["timeQueued"] ? new Date(_data["timeQueued"].toString()) : undefined as any;
      this.timeUploadEnded = _data["timeUploadEnded"] ? new Date(_data["timeUploadEnded"].toString()) : undefined as any;
      this.timeFinished = _data["timeFinished"] ? new Date(_data["timeFinished"].toString()) : undefined as any;
      this.bytesDownloaded = _data["bytesDownloaded"];
      this.bytesUploaded = _data["bytesUploaded"];
    }
  }

  static fromJS(data: any): JobStats {
    data = typeof data === 'object' ? data : {};
    let result = new JobStats();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["timeDownloadStarted"] = this.timeDownloadStarted ? this.timeDownloadStarted.toISOString() : undefined as any;
    data["timeInstructionsEnded"] = this.timeInstructionsEnded ? this.timeInstructionsEnded.toISOString() : undefined as any;
    data["timeInstructionsStarted"] = this.timeInstructionsStarted ? this.timeInstructionsStarted.toISOString() : undefined as any;
    data["timeQueued"] = this.timeQueued ? this.timeQueued.toISOString() : undefined as any;
    data["timeUploadEnded"] = this.timeUploadEnded ? this.timeUploadEnded.toISOString() : undefined as any;
    data["timeFinished"] = this.timeFinished ? this.timeFinished.toISOString() : undefined as any;
    data["bytesDownloaded"] = this.bytesDownloaded;
    data["bytesUploaded"] = this.bytesUploaded;
    return data;
  }
}

export interface IJobStats {
  timeDownloadStarted?: Date | undefined;
  timeInstructionsEnded?: Date | undefined;
  timeInstructionsStarted?: Date | undefined;
  timeQueued?: Date | undefined;
  timeUploadEnded?: Date | undefined;
  timeFinished?: Date | undefined;
  bytesDownloaded?: number | undefined;
  bytesUploaded?: number | undefined;
}

export class JobRunItemInfoBase implements IJobRunItemInfoBase {
  id?: string;
  status?: JobRunItemStatusType;

  constructor(data?: IJobRunItemInfoBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): JobRunItemInfoBase {
    data = typeof data === 'object' ? data : {};
    let result = new JobRunItemInfoBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    return data;
  }
}

export interface IJobRunItemInfoBase {
  id?: string;
  status?: JobRunItemStatusType;
}

export class PaginatedResultOfAvtItemReportSummaryDto extends PaginatedCount implements IPaginatedResultOfAvtItemReportSummaryDto {
  items?: AvtItemReportSummaryDto[];

  constructor(data?: IPaginatedResultOfAvtItemReportSummaryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(AvtItemReportSummaryDto.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfAvtItemReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfAvtItemReportSummaryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfAvtItemReportSummaryDto extends IPaginatedCount {
  items?: AvtItemReportSummaryDto[];
}

export class AvtItemReportSummaryResult extends PaginatedResultOfAvtItemReportSummaryDto implements IAvtItemReportSummaryResult {

  constructor(data?: IAvtItemReportSummaryResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): AvtItemReportSummaryResult {
    data = typeof data === 'object' ? data : {};
    let result = new AvtItemReportSummaryResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IAvtItemReportSummaryResult extends IPaginatedResultOfAvtItemReportSummaryDto {
}

export class ItemReportSummaryDto implements IItemReportSummaryDto {
  jobRunItemId?: string;
  status?: JobRunItemStatusType;
  file?: FileDto | undefined;
  summary?: ReportSummaryDto;

  constructor(data?: IItemReportSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobRunItemId = _data["jobRunItemId"];
      this.status = _data["status"];
      this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : undefined as any;
      this.summary = _data["summary"] ? ReportSummaryDto.fromJS(_data["summary"]) : undefined as any;
    }
  }

  static fromJS(data: any): ItemReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new ItemReportSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobRunItemId"] = this.jobRunItemId;
    data["status"] = this.status;
    data["file"] = this.file ? this.file.toJSON() : undefined as any;
    data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
    return data;
  }
}

export interface IItemReportSummaryDto {
  jobRunItemId?: string;
  status?: JobRunItemStatusType;
  file?: FileDto | undefined;
  summary?: ReportSummaryDto;
}

export class AvtItemReportSummaryDto extends ItemReportSummaryDto implements IAvtItemReportSummaryDto {
  /** Gets the AVT-typed report summary.
   */
  avtSummary?: AvtReportSummaryDto;
  summary?: ReportSummaryDto;
  model?: BitFile | undefined;

  constructor(data?: IAvtItemReportSummaryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.avtSummary = _data["avtSummary"] ? AvtReportSummaryDto.fromJS(_data["avtSummary"]) : undefined as any;
      this.summary = _data["summary"] ? ReportSummaryDto.fromJS(_data["summary"]) : undefined as any;
      this.model = _data["model"] ? BitFile.fromJS(_data["model"]) : undefined as any;
    }
  }

  static override fromJS(data: any): AvtItemReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new AvtItemReportSummaryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["avtSummary"] = this.avtSummary ? this.avtSummary.toJSON() : undefined as any;
    data["summary"] = this.summary ? this.summary.toJSON() : undefined as any;
    data["model"] = this.model ? this.model.toJSON() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IAvtItemReportSummaryDto extends IItemReportSummaryDto {
  /** Gets the AVT-typed report summary.
   */
  avtSummary?: AvtReportSummaryDto;
  summary?: ReportSummaryDto;
  model?: BitFile | undefined;
}

export class PaginatedResultOfAvtReportSummaryDto extends PaginatedCount implements IPaginatedResultOfAvtReportSummaryDto {
  items?: AvtReportSummaryDto[];

  constructor(data?: IPaginatedResultOfAvtReportSummaryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(AvtReportSummaryDto.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfAvtReportSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfAvtReportSummaryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfAvtReportSummaryDto extends IPaginatedCount {
  items?: AvtReportSummaryDto[];
}

export class AvtReportSummaryResult extends PaginatedResultOfAvtReportSummaryDto implements IAvtReportSummaryResult {

  constructor(data?: IAvtReportSummaryResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): AvtReportSummaryResult {
    data = typeof data === 'object' ? data : {};
    let result = new AvtReportSummaryResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IAvtReportSummaryResult extends IPaginatedResultOfAvtReportSummaryDto {
}

export class UsageRequestBase implements IUsageRequestBase {
  filter?: UsageFilterDto;
  sort?: UsageSortDto;
  options?: UsageExportOptionsDto;
  exportType?: UsageExportType;
  exportFormat?: UsageExportFormat;
  writeIfEmpty?: boolean;

  protected _discriminator: string;

  constructor(data?: IUsageRequestBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
    this._discriminator = "UsageRequestBase";
  }

  init(_data?: any) {
    if (_data) {
      this.filter = _data["filter"] ? UsageFilterDto.fromJS(_data["filter"]) : undefined as any;
      this.sort = _data["sort"] ? UsageSortDto.fromJS(_data["sort"]) : undefined as any;
      this.options = _data["options"] ? UsageExportOptionsDto.fromJS(_data["options"]) : undefined as any;
      this.exportType = _data["exportType"];
      this.exportFormat = _data["exportFormat"];
      this.writeIfEmpty = _data["writeIfEmpty"];
    }
  }

  static fromJS(data: any): UsageRequestBase {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "DetailedUsageRequest") {
      let result = new DetailedUsageRequest();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "UsageRequest") {
      let result = new UsageRequest();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "UsageSummaryRequest") {
      let result = new UsageSummaryRequest();
      result.init(data);
      return result;
    }
    let result = new UsageRequestBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["_discriminator"] = this._discriminator;
    data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
    data["sort"] = this.sort ? this.sort.toJSON() : undefined as any;
    data["options"] = this.options ? this.options.toJSON() : undefined as any;
    data["exportType"] = this.exportType;
    data["exportFormat"] = this.exportFormat;
    data["writeIfEmpty"] = this.writeIfEmpty;
    return data;
  }
}

export interface IUsageRequestBase {
  filter?: UsageFilterDto;
  sort?: UsageSortDto;
  options?: UsageExportOptionsDto;
  exportType?: UsageExportType;
  exportFormat?: UsageExportFormat;
  writeIfEmpty?: boolean;
}

export class UsageRequest extends UsageRequestBase implements IUsageRequest {
  limit?: number | undefined;
  paginationToken?: string | undefined;

  constructor(data?: IUsageRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "UsageRequest";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.limit = _data["limit"];
      this.paginationToken = _data["paginationToken"];
    }
  }

  static override fromJS(data: any): UsageRequest {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "DetailedUsageRequest") {
      let result = new DetailedUsageRequest();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "UsageSummaryRequest") {
      let result = new UsageSummaryRequest();
      result.init(data);
      return result;
    }
    let result = new UsageRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["limit"] = this.limit;
    data["paginationToken"] = this.paginationToken;
    super.toJSON(data);
    return data;
  }
}

export interface IUsageRequest extends IUsageRequestBase {
  limit?: number | undefined;
  paginationToken?: string | undefined;
}

export class DetailedUsageRequest extends UsageRequest implements IDetailedUsageRequest {
  statuses?: JobRunItemStatusType[];

  constructor(data?: IDetailedUsageRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "DetailedUsageRequest";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["statuses"])) {
        this.statuses = [] as any;
        for (let item of _data["statuses"])
          this.statuses!.push(item);
      }
    }
  }

  static override fromJS(data: any): DetailedUsageRequest {
    data = typeof data === 'object' ? data : {};
    let result = new DetailedUsageRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.statuses)) {
      data["statuses"] = [];
      for (let item of this.statuses)
        data["statuses"].push(item);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IDetailedUsageRequest extends IUsageRequest {
  statuses?: JobRunItemStatusType[];
}

export class UsageFilterDto implements IUsageFilterDto {
  customerIds?: string[];
  userIds?: string[];
  jobIds?: string[];
  jobRunIds?: string[];
  startTime?: Date | undefined;
  endTime?: Date | undefined;

  constructor(data?: IUsageFilterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["customerIds"])) {
        this.customerIds = [] as any;
        for (let item of _data["customerIds"])
          this.customerIds!.push(item);
      }
      if (Array.isArray(_data["userIds"])) {
        this.userIds = [] as any;
        for (let item of _data["userIds"])
          this.userIds!.push(item);
      }
      if (Array.isArray(_data["jobIds"])) {
        this.jobIds = [] as any;
        for (let item of _data["jobIds"])
          this.jobIds!.push(item);
      }
      if (Array.isArray(_data["jobRunIds"])) {
        this.jobRunIds = [] as any;
        for (let item of _data["jobRunIds"])
          this.jobRunIds!.push(item);
      }
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
      this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): UsageFilterDto {
    data = typeof data === 'object' ? data : {};
    let result = new UsageFilterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.customerIds)) {
      data["customerIds"] = [];
      for (let item of this.customerIds)
        data["customerIds"].push(item);
    }
    if (Array.isArray(this.userIds)) {
      data["userIds"] = [];
      for (let item of this.userIds)
        data["userIds"].push(item);
    }
    if (Array.isArray(this.jobIds)) {
      data["jobIds"] = [];
      for (let item of this.jobIds)
        data["jobIds"].push(item);
    }
    if (Array.isArray(this.jobRunIds)) {
      data["jobRunIds"] = [];
      for (let item of this.jobRunIds)
        data["jobRunIds"].push(item);
    }
    data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
    data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
    return data;
  }
}

export interface IUsageFilterDto {
  customerIds?: string[];
  userIds?: string[];
  jobIds?: string[];
  jobRunIds?: string[];
  startTime?: Date | undefined;
  endTime?: Date | undefined;
}

export class UsageSortDto implements IUsageSortDto {
  sortType?: UsageSortType;
  ascending?: boolean;

  constructor(data?: IUsageSortDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sortType = _data["sortType"];
      this.ascending = _data["ascending"];
    }
  }

  static fromJS(data: any): UsageSortDto {
    data = typeof data === 'object' ? data : {};
    let result = new UsageSortDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["sortType"] = this.sortType;
    data["ascending"] = this.ascending;
    return data;
  }
}

export interface IUsageSortDto {
  sortType?: UsageSortType;
  ascending?: boolean;
}

export class UsageExportOptionsDto implements IUsageExportOptionsDto {
  includeFullErrorInfo?: boolean;
  fileEntryLimit?: number;

  constructor(data?: IUsageExportOptionsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.includeFullErrorInfo = _data["includeFullErrorInfo"];
      this.fileEntryLimit = _data["fileEntryLimit"];
    }
  }

  static fromJS(data: any): UsageExportOptionsDto {
    data = typeof data === 'object' ? data : {};
    let result = new UsageExportOptionsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["includeFullErrorInfo"] = this.includeFullErrorInfo;
    data["fileEntryLimit"] = this.fileEntryLimit;
    return data;
  }
}

export interface IUsageExportOptionsDto {
  includeFullErrorInfo?: boolean;
  fileEntryLimit?: number;
}

export class UsageSummaryRequest extends UsageRequest implements IUsageSummaryRequest {
  statuses?: JobRunStatusType[];
  includeRuns?: boolean;

  constructor(data?: IUsageSummaryRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "UsageSummaryRequest";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["statuses"])) {
        this.statuses = [] as any;
        for (let item of _data["statuses"])
          this.statuses!.push(item);
      }
      this.includeRuns = _data["includeRuns"];
    }
  }

  static override fromJS(data: any): UsageSummaryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UsageSummaryRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.statuses)) {
      data["statuses"] = [];
      for (let item of this.statuses)
        data["statuses"].push(item);
    }
    data["includeRuns"] = this.includeRuns;
    super.toJSON(data);
    return data;
  }
}

export interface IUsageSummaryRequest extends IUsageRequest {
  statuses?: JobRunStatusType[];
  includeRuns?: boolean;
}

export class PaginatedResultOfCustomerInfo extends PaginatedCount implements IPaginatedResultOfCustomerInfo {
  items?: CustomerInfo[];

  constructor(data?: IPaginatedResultOfCustomerInfo) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(CustomerInfo.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfCustomerInfo {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfCustomerInfo();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfCustomerInfo extends IPaginatedCount {
  items?: CustomerInfo[];
}

export class CustomerInfoPaginatedResult extends PaginatedResultOfCustomerInfo implements ICustomerInfoPaginatedResult {

  constructor(data?: ICustomerInfoPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): CustomerInfoPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerInfoPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface ICustomerInfoPaginatedResult extends IPaginatedResultOfCustomerInfo {
}

export class GetRvtVersionResponse implements IGetRvtVersionResponse {
  rvtVersion?: string | undefined;

  constructor(data?: IGetRvtVersionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rvtVersion = _data["rvtVersion"];
    }
  }

  static fromJS(data: any): GetRvtVersionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetRvtVersionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["rvtVersion"] = this.rvtVersion;
    return data;
  }
}

export interface IGetRvtVersionResponse {
  rvtVersion?: string | undefined;
}

export class RecentItemsList implements IRecentItemsList {
  forgeFiles?: JobFile[];
  forgeDirectories?: JobDirectory[];
  projectWiseFiles?: ProjectWiseFile[];
  projectWiseDirectories?: ProjectWiseDirectory[];

  constructor(data?: IRecentItemsList) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["forgeFiles"])) {
        this.forgeFiles = [] as any;
        for (let item of _data["forgeFiles"])
          this.forgeFiles!.push(JobFile.fromJS(item));
      }
      if (Array.isArray(_data["forgeDirectories"])) {
        this.forgeDirectories = [] as any;
        for (let item of _data["forgeDirectories"])
          this.forgeDirectories!.push(JobDirectory.fromJS(item));
      }
      if (Array.isArray(_data["projectWiseFiles"])) {
        this.projectWiseFiles = [] as any;
        for (let item of _data["projectWiseFiles"])
          this.projectWiseFiles!.push(ProjectWiseFile.fromJS(item));
      }
      if (Array.isArray(_data["projectWiseDirectories"])) {
        this.projectWiseDirectories = [] as any;
        for (let item of _data["projectWiseDirectories"])
          this.projectWiseDirectories!.push(ProjectWiseDirectory.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RecentItemsList {
    data = typeof data === 'object' ? data : {};
    let result = new RecentItemsList();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.forgeFiles)) {
      data["forgeFiles"] = [];
      for (let item of this.forgeFiles)
        data["forgeFiles"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.forgeDirectories)) {
      data["forgeDirectories"] = [];
      for (let item of this.forgeDirectories)
        data["forgeDirectories"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.projectWiseFiles)) {
      data["projectWiseFiles"] = [];
      for (let item of this.projectWiseFiles)
        data["projectWiseFiles"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.projectWiseDirectories)) {
      data["projectWiseDirectories"] = [];
      for (let item of this.projectWiseDirectories)
        data["projectWiseDirectories"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface IRecentItemsList {
  forgeFiles?: JobFile[];
  forgeDirectories?: JobDirectory[];
  projectWiseFiles?: ProjectWiseFile[];
  projectWiseDirectories?: ProjectWiseDirectory[];
}

export class ListRecentItemsResult extends RecentItemsList implements IListRecentItemsResult {
  paginationData?: PaginationData | undefined;
  isDone?: boolean;

  constructor(data?: IListRecentItemsResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.paginationData = _data["paginationData"] ? PaginationData.fromJS(_data["paginationData"]) : undefined as any;
      this.isDone = _data["isDone"];
    }
  }

  static override fromJS(data: any): ListRecentItemsResult {
    data = typeof data === 'object' ? data : {};
    let result = new ListRecentItemsResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paginationData"] = this.paginationData ? this.paginationData.toJSON() : undefined as any;
    data["isDone"] = this.isDone;
    super.toJSON(data);
    return data;
  }
}

export interface IListRecentItemsResult extends IRecentItemsList {
  paginationData?: PaginationData | undefined;
  isDone?: boolean;
}

export class PaginatedResultOfJobFile extends PaginatedCount implements IPaginatedResultOfJobFile {
  items?: JobFile[];

  constructor(data?: IPaginatedResultOfJobFile) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(JobFile.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfJobFile {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfJobFile();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfJobFile extends IPaginatedCount {
  items?: JobFile[];
}

export class JobFilePaginatedResult extends PaginatedResultOfJobFile implements IJobFilePaginatedResult {

  constructor(data?: IJobFilePaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): JobFilePaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new JobFilePaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IJobFilePaginatedResult extends IPaginatedResultOfJobFile {
}

export class CreateDirectoryRequest implements ICreateDirectoryRequest {
  name?: string;

  constructor(data?: ICreateDirectoryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CreateDirectoryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateDirectoryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    return data;
  }
}

export interface ICreateDirectoryRequest {
  name?: string;
}

export class ListFilesResultBaseOfFile360AndDirectory360AndPaginationData implements IListFilesResultBaseOfFile360AndDirectory360AndPaginationData {
  files?: File360[];
  directories?: Directory360[];
  nextPage?: PaginationData | undefined;
  previousPage?: PaginationData | undefined;
  isDone?: boolean;

  constructor(data?: IListFilesResultBaseOfFile360AndDirectory360AndPaginationData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["files"])) {
        this.files = [] as any;
        for (let item of _data["files"])
          this.files!.push(File360.fromJS(item));
      }
      if (Array.isArray(_data["directories"])) {
        this.directories = [] as any;
        for (let item of _data["directories"])
          this.directories!.push(Directory360.fromJS(item));
      }
      this.nextPage = _data["nextPage"] ? PaginationData.fromJS(_data["nextPage"]) : undefined as any;
      this.previousPage = _data["previousPage"] ? PaginationData.fromJS(_data["previousPage"]) : undefined as any;
      this.isDone = _data["isDone"];
    }
  }

  static fromJS(data: any): ListFilesResultBaseOfFile360AndDirectory360AndPaginationData {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesResultBaseOfFile360AndDirectory360AndPaginationData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.files)) {
      data["files"] = [];
      for (let item of this.files)
        data["files"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.directories)) {
      data["directories"] = [];
      for (let item of this.directories)
        data["directories"].push(item ? item.toJSON() : undefined as any);
    }
    data["nextPage"] = this.nextPage ? this.nextPage.toJSON() : undefined as any;
    data["previousPage"] = this.previousPage ? this.previousPage.toJSON() : undefined as any;
    data["isDone"] = this.isDone;
    return data;
  }
}

export interface IListFilesResultBaseOfFile360AndDirectory360AndPaginationData {
  files?: File360[];
  directories?: Directory360[];
  nextPage?: PaginationData | undefined;
  previousPage?: PaginationData | undefined;
  isDone?: boolean;
}

export class ListFilesResultBaseOfFile360AndDirectory360 extends ListFilesResultBaseOfFile360AndDirectory360AndPaginationData implements IListFilesResultBaseOfFile360AndDirectory360 {

  constructor(data?: IListFilesResultBaseOfFile360AndDirectory360) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ListFilesResultBaseOfFile360AndDirectory360 {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesResultBaseOfFile360AndDirectory360();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IListFilesResultBaseOfFile360AndDirectory360 extends IListFilesResultBaseOfFile360AndDirectory360AndPaginationData {
}

export class ListFilesV2Result extends ListFilesResultBaseOfFile360AndDirectory360 implements IListFilesV2Result {
  /** Gets a value indicating whether an additional name check should be performed on the results.
   E.g. files with commas in the name are not detected by eq filters but are by contains filters
   So, use a contains filter, then if multiple results are returned, check the name server-side.
   */
  specialFilter?: boolean;

  constructor(data?: IListFilesV2Result) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.specialFilter = _data["specialFilter"];
    }
  }

  static override fromJS(data: any): ListFilesV2Result {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesV2Result();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["specialFilter"] = this.specialFilter;
    super.toJSON(data);
    return data;
  }
}

export interface IListFilesV2Result extends IListFilesResultBaseOfFile360AndDirectory360 {
  /** Gets a value indicating whether an additional name check should be performed on the results.
   E.g. files with commas in the name are not detected by eq filters but are by contains filters
   So, use a contains filter, then if multiple results are returned, check the name server-side.
   */
  specialFilter?: boolean;
}

export class PaginatedResultOfProject extends PaginatedCount implements IPaginatedResultOfProject {
  items?: Project[];

  constructor(data?: IPaginatedResultOfProject) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(Project.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfProject {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfProject();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfProject extends IPaginatedCount {
  items?: Project[];
}

export class ProjectPaginatedResult extends PaginatedResultOfProject implements IProjectPaginatedResult {

  constructor(data?: IProjectPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ProjectPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IProjectPaginatedResult extends IPaginatedResultOfProject {
}

export class PaginatedResultOfProjectWiseRepository extends PaginatedCount implements IPaginatedResultOfProjectWiseRepository {
  items?: ProjectWiseRepository[];

  constructor(data?: IPaginatedResultOfProjectWiseRepository) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(ProjectWiseRepository.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfProjectWiseRepository {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfProjectWiseRepository();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfProjectWiseRepository extends IPaginatedCount {
  items?: ProjectWiseRepository[];
}

export class ProjectWiseRepositoryPaginatedResult extends PaginatedResultOfProjectWiseRepository implements IProjectWiseRepositoryPaginatedResult {

  constructor(data?: IProjectWiseRepositoryPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ProjectWiseRepositoryPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseRepositoryPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IProjectWiseRepositoryPaginatedResult extends IPaginatedResultOfProjectWiseRepository {
}

export class ProjectWiseRepository implements IProjectWiseRepository {
  serverAddress?: string;
  id?: string;
  name?: string;
  credentialId?: string | undefined;

  constructor(data?: IProjectWiseRepository) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serverAddress = _data["serverAddress"];
      this.id = _data["id"];
      this.name = _data["name"];
      this.credentialId = _data["credentialId"];
    }
  }

  static fromJS(data: any): ProjectWiseRepository {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseRepository();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["serverAddress"] = this.serverAddress;
    data["id"] = this.id;
    data["name"] = this.name;
    data["credentialId"] = this.credentialId;
    return data;
  }
}

export interface IProjectWiseRepository {
  serverAddress?: string;
  id?: string;
  name?: string;
  credentialId?: string | undefined;
}

export class ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData implements IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData {
  files?: ProjectWiseFile[];
  directories?: ProjectWiseDirectory[];
  nextPage?: PaginationData | undefined;
  previousPage?: PaginationData | undefined;
  isDone?: boolean;

  constructor(data?: IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["files"])) {
        this.files = [] as any;
        for (let item of _data["files"])
          this.files!.push(ProjectWiseFile.fromJS(item));
      }
      if (Array.isArray(_data["directories"])) {
        this.directories = [] as any;
        for (let item of _data["directories"])
          this.directories!.push(ProjectWiseDirectory.fromJS(item));
      }
      this.nextPage = _data["nextPage"] ? PaginationData.fromJS(_data["nextPage"]) : undefined as any;
      this.previousPage = _data["previousPage"] ? PaginationData.fromJS(_data["previousPage"]) : undefined as any;
      this.isDone = _data["isDone"];
    }
  }

  static fromJS(data: any): ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.files)) {
      data["files"] = [];
      for (let item of this.files)
        data["files"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.directories)) {
      data["directories"] = [];
      for (let item of this.directories)
        data["directories"].push(item ? item.toJSON() : undefined as any);
    }
    data["nextPage"] = this.nextPage ? this.nextPage.toJSON() : undefined as any;
    data["previousPage"] = this.previousPage ? this.previousPage.toJSON() : undefined as any;
    data["isDone"] = this.isDone;
    return data;
  }
}

export interface IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData {
  files?: ProjectWiseFile[];
  directories?: ProjectWiseDirectory[];
  nextPage?: PaginationData | undefined;
  previousPage?: PaginationData | undefined;
  isDone?: boolean;
}

export class ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory extends ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData implements IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory {

  constructor(data?: IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory {
    data = typeof data === 'object' ? data : {};
    let result = new ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory extends IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectoryAndPaginationData {
}

export class ListProjectWiseFilesResult extends ListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory implements IListProjectWiseFilesResult {

  constructor(data?: IListProjectWiseFilesResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ListProjectWiseFilesResult {
    data = typeof data === 'object' ? data : {};
    let result = new ListProjectWiseFilesResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IListProjectWiseFilesResult extends IListFilesResultBaseOfProjectWiseFileAndProjectWiseDirectory {
}